webpackJsonp([156961625477706],{

/***/ 113:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1010:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 1011:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 1012:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 399:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.TrafficLightExample = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _schviz = __webpack_require__(13);
	
	var _schviz2 = _interopRequireDefault(_schviz);
	
	var _trafficLight = __webpack_require__(897);
	
	var _trafficLight2 = _interopRequireDefault(_trafficLight);
	
	var _trafficLight3 = __webpack_require__(400);
	
	var _trafficLight4 = _interopRequireDefault(_trafficLight3);
	
	var _trafficLight5 = __webpack_require__(896);
	
	var _trafficLight6 = _interopRequireDefault(_trafficLight5);
	
	var _components = __webpack_require__(68);
	
	var _common = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TrafficLightExample = exports.TrafficLightExample = function (_SCComponent) {
	  _inherits(TrafficLightExample, _SCComponent);
	
	  function TrafficLightExample(props) {
	    _classCallCheck(this, TrafficLightExample);
	
	    //wait for promise to resolve, then set up setInterval to send tick events into the state machine
	    var _this = _possibleConstructorReturn(this, _SCComponent.call(this, props, _trafficLight2.default));
	
	    _this.scPromise.then(function (sc) {
	      return _this.handle = setInterval(function () {
	        return sc.gen('tick');
	      }, 1000);
	    });
	    return _this;
	  }
	
	  TrafficLightExample.prototype.componentWillUnmount = function componentWillUnmount() {
	    clearInterval(this.handle);
	  };
	
	  TrafficLightExample.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'table',
	        { style: { width: '100%', height: '400px' } },
	        _react2.default.createElement(
	          'tbody',
	          null,
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(_common.Cell, {
	              contentHeight: '400px',
	              showSourceCode: this.state.showSourceCode,
	              sourceCode: _trafficLight6.default,
	              component: _react2.default.createElement(_trafficLight4.default, { configuration: this.state.configuration, datamodel: this.state.datamodel }),
	              caption: _react2.default.createElement(
	                'span',
	                null,
	                'I am a ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'traffic light'
	                )
	              )
	            }),
	            _react2.default.createElement(_common.Cell, {
	              contentHeight: '400px',
	              showSourceCode: this.state.showSourceCode,
	              sourceCode: _trafficLight2.default,
	              component: _react2.default.createElement(_schviz2.default, {
	                scxmlDocumentString: _trafficLight2.default,
	                disableAnimation: true,
	                configuration: this.state && this.state.configuration,
	                disableZoomAnimation: true,
	                transitionsEnabled: this.state && this.state.transitionsEnabled,
	                id: 'trafficLight',
	                expandAllStatesByDefault: true,
	                layoutOptions: _schviz2.default.layouts.auto
	              }),
	              caption: _react2.default.createElement(
	                'span',
	                null,
	                'I am a ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'state machine'
	                )
	              )
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(_components.ShowHideSourceCodeLink, { self: this })
	    );
	  };
	
	  return TrafficLightExample;
	}(_common.SCComponent);

/***/ }),

/***/ 708:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 400:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Traffic_lights_dark_green = __webpack_require__(1010);
	
	var _Traffic_lights_dark_green2 = _interopRequireDefault(_Traffic_lights_dark_green);
	
	var _Traffic_lights_dark_red = __webpack_require__(1011);
	
	var _Traffic_lights_dark_red2 = _interopRequireDefault(_Traffic_lights_dark_red);
	
	var _Traffic_lights_dark_yellow = __webpack_require__(1012);
	
	var _Traffic_lights_dark_yellow2 = _interopRequireDefault(_Traffic_lights_dark_yellow);
	
	__webpack_require__(113);
	
	__webpack_require__(708);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TrafficLight = function TrafficLight(_ref) {
	  var configuration = _ref.configuration,
	      datamodel = _ref.datamodel;
	  return _react2.default.createElement(
	    'div',
	    { className: 'traffic-light-example' },
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement('div', {
	        className: 'fill-image',
	        style: {
	          backgroundImage: 'url(' + function () {
	            switch (configuration && configuration[0]) {
	              case 'stop':
	                return _Traffic_lights_dark_red2.default;
	              case 'warn':
	                return _Traffic_lights_dark_yellow2.default;
	              case 'go':
	                return _Traffic_lights_dark_green2.default;
	              default:
	                return null;
	            }
	          }() + ')'
	        } })
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      'Interval: ',
	      datamodel && datamodel.interval
	    )
	  );
	};
	
	exports.default = TrafficLight;
	module.exports = exports['default'];

/***/ }),

/***/ 896:
/***/ (function(module, exports) {

	module.exports = "import React from 'react'\nimport green from './Traffic_lights_dark_green.svg';\nimport red from './Traffic_lights_dark_red.svg';\nimport yellow from './Traffic_lights_dark_yellow.svg';\nimport '../common.css';\nimport './traffic-light.css';\n\nconst TrafficLight = ({configuration, datamodel}) => (\n  <div className=\"traffic-light-example\">\n    <div>\n      <div \n        className=\"fill-image\"\n        style={{\n          backgroundImage:`url(${\n            (() => {\n              switch(configuration && configuration[0]){\n                case 'stop': return red;\n                case 'warn': return yellow;\n                case 'go': return green;\n                default: return null;\n              }\n            })()\n          })`\n        }}/>\n    </div>\n    <div>Interval: {datamodel && datamodel.interval}</div>\n  </div>\n)\n\nexport default TrafficLight; \n"

/***/ }),

/***/ 897:
/***/ (function(module, exports) {

	module.exports = "<scxml>\n  \n  <datamodel>\n    <data id=\"interval\" expr=\"0\"/>\n    <data id=\"stop_t\" expr=\"6\"/>\n    <data id=\"warn_t\" expr=\"2\"/>\n    <data id=\"go_t\" expr=\"8\"/>\n  </datamodel>\n  \n  <state id=\"stop\">\n    <transition event=\"tick\" cond=\"interval < stop_t\">\n      <assign location=\"interval\" expr=\"interval + 1\" />\n    </transition>\n    <transition event=\"tick\" cond=\"interval == stop_t\" target=\"go\">\n      <assign location=\"interval\" expr=\"0\" />\n    </transition>\n  </state>\n  \n  <state id=\"warn\">\n    <transition event=\"tick\" cond=\"interval < warn_t\">\n      <assign location=\"interval\" expr=\"interval + 1\" />\n    </transition>\n    <transition event=\"tick\" cond=\"interval == warn_t\" target=\"stop\">\n      <assign location=\"interval\" expr=\"0\" />\n    </transition>\n  </state>\n  \n  <state id=\"go\">\n    <transition event=\"tick\" cond=\"interval < go_t\">\n      <assign location=\"interval\" expr=\"interval + 1\" />\n    </transition>\n    <transition event=\"tick\" cond=\"interval == go_t\" target=\"warn\">\n      <assign location=\"interval\" expr=\"0\" />\n    </transition>\n  </state>\n  \n</scxml>\n"

/***/ }),

/***/ 425:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var React = _interopRequireWildcard(_react);
	
	var _TutorialPageWrapper = __webpack_require__(18);
	
	var _TutorialPageWrapper2 = _interopRequireDefault(_TutorialPageWrapper);
	
	var _trafficLight = __webpack_require__(399);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var ConditionalTransitions = function ConditionalTransitions(_ref) {
	  var sectionName = _ref.sectionName,
	      by = _ref.by;
	  return React.createElement(
	    'div',
	    { className: 'container' },
	    React.createElement(
	      'h1',
	      null,
	      sectionName
	    ),
	    React.createElement(
	      'h6',
	      null,
	      by
	    ),
	    React.createElement(
	      'p',
	      null,
	      'By this point you probably understand generally how statecharts work. In this section we\u2019ll discuss less ubiquitous features of SCXML that nonetheless will come in handy in certain circumstances.'
	    ),
	    React.createElement(
	      'p',
	      null,
	      'Occasionally a state machine needs to react to an event differently depending on the situation. Are all of the criteria met to transition to this state, or do we need to transition to that state instead?'
	    ),
	    React.createElement(
	      'p',
	      null,
	      'Let\u2019s consider a situation where we want the logic for a traffic light to be entirely handled by a statechart. The only event the interpreter will receive is ',
	      React.createElement(
	        'code',
	        null,
	        '"tick"'
	      ),
	      ', given at an evenly but arbitrarily spaced interval of time. When the interpreter hears a tick, it may need to change the lights, but it may need to keep its present configuration. How do we decide?'
	    ),
	    React.createElement(
	      'h2',
	      null,
	      ' Enter ',
	      React.createElement(
	        'code',
	        null,
	        'cond'
	      ),
	      ' '
	    ),
	    React.createElement(
	      'p',
	      null,
	      'The ',
	      React.createElement(
	        'code',
	        null,
	        'cond'
	      ),
	      ' attribute lets us specify an expression that the statechart has to evaluate to determine which ',
	      React.createElement(
	        'code',
	        null,
	        '<transition>'
	      ),
	      ' to follow. Using ',
	      React.createElement(
	        'code',
	        null,
	        'cond'
	      ),
	      ', we can set up the traffic lights\u2019 statechart this way:'
	    ),
	    React.createElement(_trafficLight.TrafficLightExample, null),
	    React.createElement(
	      'p',
	      null,
	      'While it isn\u2019t time to change lights, we transition to the same state after adding 1 to ',
	      React.createElement(
	        'code',
	        null,
	        'interval'
	      ),
	      '. This is totally legal and a useful pattern in situations where it\u2019s still useful to react to the event without transitioning to a new state. The earlier example in 1.3 used this same pattern to update the position of the element while dragging was still underway.'
	    ),
	    React.createElement(
	      'p',
	      null,
	      'Using ',
	      React.createElement(
	        'code',
	        null,
	        'cond'
	      ),
	      ', we give the statechart all of the logic pertaining to changing the lights, and it\u2019s only up to the interpreter\u2019s environment to keep track of time by firing ',
	      React.createElement(
	        'code',
	        null,
	        '"tick"'
	      ),
	      ' on some interval.'
	    )
	  );
	};
	
	var WrappedConditionalTransitions = function WrappedConditionalTransitions(_ref2) {
	  var location = _ref2.location;
	  return React.createElement(_TutorialPageWrapper2.default, { Component: ConditionalTransitions, pathname: location.pathname });
	};
	
	exports.default = WrappedConditionalTransitions;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-tutorials-conditional-transitions-js-1dcea6164d6d92314141.js